import { useRouter } from "@tanstack/react-router";
import { MappingWorkspace } from "@/components/staffing-requests/MappingWorkspace";

interface Props {
  id: string;
}

export function StaffingRequestDetailPage({ id }: Props) {
  const router = useRouter();

  function handleBack() {
    router.navigate({ to: "/dashboard/staffing-requests" });
  }

  return <MappingWorkspace requestId={id} onBack={handleBack} />;
}
